import { Autocomplete, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormLabel, MenuItem, Select, TextField } from '@mui/material';
import { Modal, Typography } from "@mui/material";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '@mui/material';
import { Box } from '@mui/material';
import { FormControl } from '@mui/material';
import { InputLabel } from '@mui/material';
import { Stack } from '@mui/material';
import APIManager from '../../../../lib/apiManager';
import { CheckBox } from '@mui/icons-material';

const NuevoModal = ({ open, setOpen, selectedItem, columns, setSelectedItem, agrupaciones }) => {
  const [nombre, setNombre] = useState('');
  const [agrupacion, setAgrupacion] = useState(null);
  const [active, setActive] = useState(false);

  const navigate = useNavigate();

  const handleContinuar = () => {
    // const nuevoItem = Object.assign({}, selectedItem, { name: nombre, agrupacion_id: agrupacion.id });
    const nuevoItem = {id: selectedItem?.id, name: nombre, agrupacion_id: agrupacion?.id, active: active };
    setSelectedItem(nuevoItem);
    setOpen(false);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleCancel = () => {
    handleClose();
  }

  const handleChangeNombre = (event) => {
    setNombre(event.target.value);
  }

  const handleChangeAgrupacion = (event, item) => {
    setAgrupacion(item);
  }

  const handleActive = (event) => {
    setActive(event.target.checked);
  }

  useEffect(() => {
    console.log('selectedItem changed', selectedItem);
    setNombre(selectedItem?.nombre ?? '');
    setAgrupacion(agrupaciones?.find(item => item.id == selectedItem?.agrupacion_id ?? '') ?? null);
    setActive(!!selectedItem?.active);
  }, [selectedItem]);

  return (
    <Dialog
    open={open}
    aria-labelledby="nuevoContrato-dialog-title"
    aria-describedby="nuevoContrato-dialog-description"
  >
      <DialogTitle id="alert-dialog-title">
        Profesion / Rubro
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="nuevoContrato-dialog-description">
           Ingrese los datos
        </DialogContentText>
        <Stack spacing={2} marginTop={2}>
          <TextField variant="standard" fullWidth
            label="Nombre"
            value={nombre}
            onChange={handleChangeNombre}
          />
          <Autocomplete fullWidth
            value={agrupacion}
            onChange={handleChangeAgrupacion}
            options={agrupaciones}
            getOptionLabel={item => item?.nombre ?? ''}
            isOptionEqualToValue={(option, value) => value?.id == option?.id}
            renderInput={(params) =>
              <TextField variant="standard" {...params} label="Grupo" />
            }
            title={agrupacion?.nombre ?? ''}
          />
          <FormControl fullWidth>
            <FormControlLabel label="Activo" control={
              <Checkbox checked={active} onChange={handleActive} />
            } />
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancelar</Button>
        <Button onClick={handleContinuar} disabled={!nombre}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NuevoModal;